import { useCallback } from 'react'
import { hasSiteChanged } from 'lib/netsuiteUtils'
import { SchoolLookUpSiteData } from 'types'

interface UseSiteChangeDetectionOptions {
  initialSiteData: Partial<SchoolLookUpSiteData>
  isInitialLoad: boolean
}

/**
 * Hook for detecting if site data has changed from initial values
 */
export const useSiteChangeDetection = ({
  initialSiteData,
  isInitialLoad,
}: UseSiteChangeDetectionOptions) => {
  const checkSiteChanged = useCallback(
    (currentSiteData: Partial<SchoolLookUpSiteData>): boolean => {
      return hasSiteChanged(currentSiteData, initialSiteData, isInitialLoad)
    },
    [initialSiteData, isInitialLoad],
  )

  return {
    checkSiteChanged,
  }
}
